import React, { useEffect } from 'react';

import constants from '../statics/constants';
import useImage from '../hooks/useImage';
import DownloadQr from '../components/DownloadQr';

/**
 * @description MyKeepin 다운로드를 위한 페이지
 */
function DownloadPage() {
  // Image Redux사용
  const { image, check, onStoreAndroid, onStoreIos } = useImage();

  // 고해상도 이미지 랜더링
  useEffect(() => {
    if (!check(image.store_android)) onStoreAndroid();
    if (!check(image.store_ios)) onStoreIos();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="download-page container">
      <div className="wrapper">
        <div className="download-title">
          <p className="text-title bold">
            매번 번거로웠던 인증을 마이키핀 하나로 관리해보세요
          </p>
          <img src={image.mykeepin_banner} alt="MYKEEPiN banner" />
        </div>
        <p className="download-desc text-body">
          스마트폰으로 QR코드를 스캔하면 설치페이지로 이동합니다.
        </p>
        <DownloadQr
          android={constants.app_store.android}
          android_btn={image.store_android}
          ios={constants.app_store.ios}
          ios_btn={image.store_ios}
        />
      </div>
    </div>
  );
}

export default DownloadPage;
